import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

interface SearchBarProps {
  onChange: (input: string) => void;
  className?: string;
  placeholder?: string;
}

export const SearchBar: React.FunctionComponent<SearchBarProps> = ({
  onChange,
  className,
  placeholder = 'Search by app name',
}): JSX.Element => {
  return (
    <div className={`${className}`}>
      <form onSubmit={(e) => e.preventDefault()}>
        <label
          className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
          htmlFor="default-search"
        >
          Search
        </label>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <FontAwesomeIcon icon={faSearch} />
          </div>
          <input
            className="block w-full p-4 pl-10 text-sm text-gray-900 border border-gray-200 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            data-testid="app-search"
            id="app-search"
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            type="search"
          />
        </div>
      </form>
    </div>
  );
};
